import { ReactNode, forwardRef } from 'react';
import { SxProps, Theme, Typography, TypographyProps } from '@mui/material';

import { CustomPaletteColorType } from '../../theme/app.theme';

interface ITitleProps extends Omit<TypographyProps, 'variant' | 'color'> {
  children: ReactNode;
  variant?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  className?: string;
  color?: CustomPaletteColorType | string;
}

interface IPageTitleProps extends ITitleProps {
  sx?: SxProps<Theme>;
}

export const PrimaryTitle = forwardRef<HTMLSpanElement, ITitleProps>(
  ({ variant = 'h4', className, children, ...props }, ref) => {
    return (
      <PageTitle
        ref={ref}
        variant={variant}
        color={'black'}
        className={className}
        {...props}
      >
        {children}
      </PageTitle>
    );
  }
);

export const SecondaryTitle = forwardRef<HTMLSpanElement, IPageTitleProps>(
  ({ variant = 'h4', className, children, ...props }, ref) => {
    return (
      <PageTitle
        ref={ref}
        variant={variant}
        color={'black'}
        className={className}
        {...props}
      >
        {children}
      </PageTitle>
    );
  }
);

export const PageTitle = forwardRef<HTMLSpanElement, IPageTitleProps>(
  ({ variant = 'h4', color, className, children, sx, ...props }, ref) => {
    return (
      <Typography
        ref={ref}
        variant={variant}
        color={'black'}
        className={className}
        sx={sx}
        {...props}
      >
        {children}
      </Typography>
    );
  }
);
